import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AnimatedLetters from "../AnimatedLetters";
import "./index.scss";
import Logo from "./Logo";
import Loader from "react-loaders";

const Home = () => {
  const [letterClass, setLetterClass] = useState("text-animate");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  const nameArray = [
    "a",
    "v",
    "i",
    "n",
    "e",
    " ",
    "N",
    "a",
    "a",
    "m",
    "a",
    "n",
  ];
  const jobArray = [
    "S",
    "o",
    "f",
    "t",
    "w",
    "a",
    "r",
    "e",
    " ",
    "E",
    "n",
    "g",
    "i",
    "n",
    "e",
    "e",
    "r",
    ".",
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 4000);
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <div className="container home-page">
        <div className="home-content">
          <div className="text-zone">
            <h1>
              <span className={letterClass}>H</span>
              <span className={`${letterClass} _12`}>i,</span>
              <br />
              <span className={`${letterClass} _13`}>I'</span>
              <span className={`${letterClass} _14`}>m</span>
              <span className="text-m"> M</span>
              <AnimatedLetters
                letterClass={letterClass}
                strArray={nameArray}
                idx={15}
              />
              <br />
              <AnimatedLetters
                letterClass={letterClass}
                strArray={jobArray}
                idx={18}
              />
            </h1>
            <h2>
              {isMobile ? (
                <>
                <p>
                  Software Engineer | Full-Stack JavaScript<br />
                  (React Native, React, Next.js) | Node.js<br />
                  & Express REST APIs | AI RAG Chatbots<br />
                  | MySQL | MS SQL
                  </p>
                </>
              ) : (
                "Software Engineer | Full-Stack JavaScript (React Native, React, Next.js) | Node.js & Express REST APIs | AI RAG Chatbots | MySQL | MS SQL"
              )}
            </h2>
            <div className="btnContainer">
              <Link to="/contact" className="flat-button">
                CONTACT ME
              </Link>
              <a
                href="mavineOyugiResume.pdf"
                download={"mavineOyugiResume.pdf"}
                className="primaryBtn"
              >
                Download CV
              </a>
            </div>
          </div>
          {!isMobile && <Logo />}
        </div>
        {isMobile && <Logo />}
      </div>
      <Loader type="pacman" />
    </>
  );
};
export default Home;